<script lang="ts">
  import CopyIcon from "$lib/icons/CopyIcon.svelte";

  interface Props {
    name: string;
    value: string;
    isEllipsis?: boolean;
  }

  let { name, value, isEllipsis = false }: Props = $props();

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch (err) {
    }
  }
</script>

<div class="w-full flex justify-between items-center">
  <span class="text-gray-500">{name}</span>
  {#if isEllipsis}
    <div class="flex items-center gap-2">
      <span class="truncate max-w-[150px]" title={value}>{value}</span>
      <button
          class="text-blue-500 hover:text-blue-700"
          onclick={copyToClipboard}
          title="Copy to clipboard"
      >
        <CopyIcon />
      </button>
    </div>
  {:else}
    <span>{value}</span>
  {/if}
</div>